var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/arrow-down-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9170795,16.8615446 L5.2414453,10.1859104 C4.91951823,9.86394974 4.91951823,9.34199651 5.2414453,9.02006944 L6.0200479,8.24146684 C6.3414718,7.92004294 6.86238515,7.91943914 7.18454703,8.24009151 L12.5000168,13.5306377 L17.815453,8.24009151 C18.1376148,7.91943914 18.6585282,7.92004294 18.9799521,8.24146684 L19.7585547,9.02006944 C20.0804818,9.34203005 20.0804818,9.86398328 19.7585547,10.1859104 L13.082954,16.8615446 C12.7609934,17.1834717 12.2390402,17.1834717 11.9170795,16.8615446 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-down-light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-down",
    fill: "#6C7D80",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colour/complementary/blue",
    mask: "url(#mask-2)",
    fill: "#1C7B97"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.000000, -28.000000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLight);
export default __webpack_public_path__ + "static/media/arrow-down-light.227f106a.svg";
export { ForwardRef as ReactComponent };